'use strict';

module.exports = /* @ngInject */ function() {

	let myself;

	this.setMyself = (user) => myself = user;

	this.$get = /* @ngInject */ function ($resource, apiConfig) {
		return {
			/**
			 * Representation of logged in User. Consists of userId, firstname, lastname and language
			 */
			getMyself: myself ? {get: () => ({$promise: Promise.resolve(myself)})} :
				$resource(
					apiConfig.$get().apiUrl + '/myself',
					{}
				),
			getMyCompanyCustomer:
				$resource(
					apiConfig.$get().apiUrl + '/customer/company/myself',
					{}
				),
			getMyCompanySupplier:
				$resource(
					apiConfig.$get().apiUrl + '/company/supplier/myself',
					{}
				),
            USER_TYPES: {
			    CUSTOMER: 'CUSTOMER',
                ADMIN: 'ADMIN',
                SUPPLIER: 'SUPPLIER'
            }
		}
	}
}
